import { render, staticRenderFns } from "./region-selector.vue?vue&type=template&id=9bbe6b1c&scoped=true&"
import script from "./region-selector.vue?vue&type=script&lang=js&"
export * from "./region-selector.vue?vue&type=script&lang=js&"
import style0 from "./region-selector.vue?vue&type=style&index=0&id=9bbe6b1c&scoped=true&lang=css&"
import style1 from "./region-selector.vue?vue&type=style&index=1&id=9bbe6b1c&scoped=true&lang=css&"
import style2 from "./region-selector.vue?vue&type=style&index=2&id=9bbe6b1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bbe6b1c",
  null
  
)

export default component.exports